module.exports = __webpack_public_path__ + "static/img/bg75.ffb9d257.png";